import _ from 'lodash';
import NavBarBaseCtrl from './NavBarBaseCtrl';

export default ['StateUtils', '$state', '$scope', 'StateUtils', '$rootScope', (StateUtils, $state, $scope, $element, $rootScope) => {
    const ctrl = new NavBarBaseCtrl($scope, $element, 'baseFnolWizard');

    ctrl.init = () => {
        /* Tab control. */
        $scope.currentTab = _.constant('none');
    };

    /* Do not show the 'Add Another Policy' link if user is navigating the FNOL wizard */
    ctrl.displayAddPolicyLink = () => {
        return $rootScope.authData && !StateUtils.hasState('baseFnolWizard');
    };

    return ctrl.create($scope);
}];
